import React, { useEffect, useRef, useState } from 'react';

import styles from './index.module.css';

const TranslateIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox='0 0 256 256' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <path d='M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.76,87.76,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z' />
  </svg>
);

/**
 * Language selector for the member-facing questionnaire, styled after the
 * conversation-room translation toggle. options is a list of { code, name },
 * including English; value is the active locale code.
 */
const LanguageSwitcher = ({ options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const closeMenu = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', closeMenu);
    return () => document.removeEventListener('mousedown', closeMenu);
  }, [open]);

  const current = options.find((option) => option.code === value) || options[0];

  return (
    <div className={styles.wrap} ref={rootRef}>
      <button
        type='button'
        className={styles.toggle}
        onClick={() => setOpen((previous) => !previous)}
        aria-haspopup='listbox'
        aria-expanded={open}
        aria-label='Change language'
        title='Change language'
      >
        <span className={styles.icon} aria-hidden='true'>
          <TranslateIcon />
        </span>
        <span className={styles.label} translate='no'>
          {current ? current.name : 'Language'}
        </span>
      </button>
      {open && (
        <div className={styles.menu} role='listbox' aria-label='Select language'>
          {options.map((option) => (
            <button
              key={option.code}
              type='button'
              role='option'
              aria-selected={option.code === value}
              className={styles.option}
              onClick={() => {
                onChange(option.code);
                setOpen(false);
              }}
            >
              {option.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
